enum JourneyStepKind {
  IntroTermConfirm = 'introTermConfirm',
  SubscriberEnrollment = 'subscriberEnrollment',
  Quiz = 'quiz',
  QuizNegativeIdentification = 'quizNegativeIdentification',
  OfferSelection = 'offerSelection',
  JourneyClosed = 'journeyClosed',
  RedirectToPortalDigital = 'redirectToPortalDigital',
  RedirectToIframe = 'redirectToIframe',
}

export default JourneyStepKind;
